import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

//#region Thư viện mẫu báo cáo
const reportTemplateLibrary = defineAsyncComponent(() =>
  import('@/views/budgetPlan/reportTemplateLibrary/ReportTemplateLibrary.vue'),
);
const shareLocation = defineAsyncComponent(() => import('@/views/budgetPlan/reportTemplateLibrary/ShareLocation.vue'));
const showReportTemplate = defineAsyncComponent(() =>
  import('@/views/budgetPlan/reportTemplateLibrary/ShowReportTemplate.vue'),
);
const displaySettingsFrame = defineAsyncComponent(() =>
  import('@/views/budgetPlan/reportTemplateLibrary/displaySettings/DisplaySettingsFrame.vue'),
);
const receiptExpenseReportB61B62Tab = defineAsyncComponent(() =>
  import(
    '@/views/budgetPlan/reportTemplateLibrary/displaySettings/displaySettingsDetail/ReceiptExpenseReportB61B62Tab.vue'
  ),
);
const reportSpendingTargetTab = defineAsyncComponent(() =>
  import('@/views/budgetPlan/reportTemplateLibrary/displaySettings/displaySettingsDetail/ReportSpendingTargetTab.vue'),
);
const activityTemplateBySymmetricalTab = defineAsyncComponent(() =>
  import(
    '@/views/budgetPlan/reportTemplateLibrary/displaySettings/displaySettingsDetail/ActivityTemplateBySymmetricalTab.vue'
  ),
);
const templateReceiptExpenseTab = defineAsyncComponent(() =>
  import(
    '@/views/budgetPlan/reportTemplateLibrary/displaySettings/displaySettingsDetail/TemplateReceiptExpenseTab.vue'
  ),
);
//#endregion

const popupBudgetPlan = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanReceiptAddMLNSDetail.vue'),
);
const popupBUPlanAdjustMLNS = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanReceiptAdjustMLNSDetail.vue'),
);
const popupBUPlanAddTT342 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanReceiptAddTT342Detail.vue'),
);
const popupBUPlanAdjustTT342 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanReceiptAdjustTT342Detail.vue'),
);
const popupBUPlanAddTT343 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanReceiptAddTT343Detail.vue'),
);
const popupBUPlanAdjustTT343 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanReceiptAdjustTT343Detail.vue'),
);
const popupBUPlanAddTT344 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanReceiptAddTT344Detail.vue'),
);
const popupBUPlanAdjustTT344 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanReceiptAdjustTT344Detail.vue'),
);
const popupBudgetPlanUtility = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUPlanGenerateBudgetPopup.vue'),
);
const popupInvestmentPlanXDCB = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buInvestmentPlanXDCB/BUInvestmentPlanXDCBDetail.vue'),
);
const popupFinancialActivities = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buFinancialActivities/BUFinancialActivitiesDetail.vue'),
);
const popupTemplateReceiptTT342 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planTemplateReceipt/TT342/BUPlanTemplateReceiptTT342Detail.vue'),
);
const popupTemplateReceiptFormularTT342 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planTemplateReceipt/TT342/BUPlanTemplateReceiptFormularTT342Popup.vue'),
);
const popupTemplateExpenseTT342 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planTemplateExpense/TT342/BUPlanTemplateExpenseTT342Detail.vue'),
);
const popupTemplateExpenseFormularTT342 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planTemplateExpense/TT342/BUPlanTemplateExpenseFormularTT342Popup.vue'),
);
const popupTemplateReceiptTT343_344 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planTemplateReceipt/TT343_344/BUPlanTemplateReceiptTT343_344Detail.vue'),
);
const popupTemplateReceiptFormularTT343_344 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planTemplateReceipt/TT343_344/BUPlanTemplateReceiptFormularTT343_344Popup.vue'),
);
const popupTemplateExpenseTT343_344 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planTemplateExpense/TT343_344/BUPlanTemplateExpenseTT343_344Detail.vue'),
);
const popupTemplateExpenseFormularTT343_344 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planTemplateExpense/TT343_344/BUPlanTemplateExpenseFormularTT343_344Popup.vue'),
);
const popupAddMLNSPrintPopup = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUAddMLNSPrintPopup.vue'),
);
const popupBUChooseBudgetSupplementAdjust = defineAsyncComponent(() =>
  import('@/views/budgetPlan/planReceiptByBudget/BUChooseBudgetSupplementAdjustPopup.vue'),
);
const buTransferDetail = defineAsyncComponent(() => import('@/views/budgetPlan/buTransfer/BUTransferDetail.vue'));
const buTransferDepositDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buTransfer/BUTransferDepositDetail.vue'),
);
const buCancelPlanDetail = defineAsyncComponent(() => import('@/views/budgetPlan/buPlanCancel/BUPlanCancelDetail.vue'));
const buBudgetReserveDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buBudgetReserve/BUBudgetReserveDetail.vue'),
);

const buPlanExpenseByBudgetSupplementDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByBudgetSupplementDetail.vue'),
);
const buPlanExpenseByActivitySupplement342Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByActivitySupplement342Detail.vue'),
);
const buPlanExpenseByActivitySupplement343Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByActivitySupplement343Detail.vue'),
);
const buPlanExpenseByActivitySupplementAdjust343Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByActivitySupplementAdjust343Detail.vue'),
);
const buPlanExpenseByActivitySupplement344Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByActivitySupplement344Detail.vue'),
);
const buPlanExpenseByActivitySupplementAdjust344Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByActivitySupplementAdjust344Detail.vue'),
);
const buPlanExpenseByActivitySupplementVtDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByActivitySupplementVtDetail.vue'),
);
const buPlanExpenseByActivitySupplementAdjustVtDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByActivitySupplementAdjustVtDetail.vue'),
);
const buPlanExpenseByActivitySupplementAdjust342Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByActivitySupplementAdjust342Detail.vue'),
);
const buPlanExpenseByBudgetSupplementAdjustDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanExpenseByBudget/BUPlanExpenseByBudgetSupplementAdjustDetail.vue'),
);
// Bảng kê thanh toán tạm ứng
const buAdvancePaymentDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buCreateDeclareTable/BUAdvancePaymentDetail.vue'),
);
// Bảng kê ghi thu ghi chi
const buReceiptExpenseDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buCreateDeclareTable/BUReceiptExpenseDetail.vue'),
);
// Bảng kê chứng từ thực chi
const buAdvancePaymentExpenceDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buCreateDeclareTable/BUAdvancePaymentExpenceDetail.vue'),
);
const buTreasuryWithdrawalDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buCashFund/BUTreasuryWithdrawalDetail.vue'),
);
const voucherNotReference = defineAsyncComponent(() => import('@/views/budgetPlan/VoucherNotReference.vue'));

const buPlanSummaryReceiptMLNSDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanSummary/BUPlanSummaryReceiptMLNSDetail.vue'),
);
const buPlanSummaryReceiptTT342Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanSummary/BUPlanSummaryReceiptTT342Detail.vue'),
);
const buPlanSummaryReceiptTT343Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanSummary/BUPlanSummaryReceiptTT343Detail.vue'),
);
const buPlanSummaryReceiptTT344Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanSummary/BUPlanSummaryReceiptTT344Detail.vue'),
);
const buPlanSummaryPaymentMLNSDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanSummary/BUPlanSummaryPaymentMLNSDetail.vue'),
);
const buPlanSummaryPaymentTT342Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanSummary/BUPlanSummaryPaymentTT342Detail.vue'),
);
const buPlanSummaryPaymentTT343Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanSummary/BUPlanSummaryPaymentTT343Detail.vue'),
);
const buPlanSummaryPaymentTT344Detail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanSummary/BUPlanSummaryPaymentTT344Detail.vue'),
);

const buAdjustmentDetail = defineAsyncComponent(() => import('@/views/budgetPlan/buAdjustment/BUAdjustmentDetail.vue'));

const buPlanCommitExpenseDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanCommitExpense/BUPlanCommitExpenseDetail.vue'),
);

const buPlanAdjustCommitDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanAdjustCommit/BUPlanAdjustCommitDetail.vue'),
);

const buPlanCommitExpenseSelect = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanAdjustCommit/popup/BUPlanCommitExpenseSelect.vue'),
);

const buGetDataAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buAdjustment/BUGetDataAdjustmentDetail.vue'),
);

const buEceiveBudgetPlanDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/receiveBudgetPlan/BUReceiveBudgetPlanDetail.vue'),
);
const buPlanAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/receiveBudgetPlan/BUPlanAdjustmentDetail.vue'),
);

const budgetPlanAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/budgetPlanAdjustment/BudgetPlanAdjustmentDetail.vue'),
);

/**
 * Biểu số 61: Quyết toán thu NSNN, vay NSĐP (TT số 342/2016/TT-BTC)
 * nhhoang1 14.04.2023
 */
const popupBUPlanReceiptExpenseReportB61B62 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/BUPlanReceiptExpenseReportB61B62.vue'),
);

const popupBUPlanReceiptExpenseReportB48 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/BUPlanReceiptExpenseReportB48.vue'),
);

/**
 * Biểu số 51: Quyết toán chi ngân sách địa phương theo lĩnh vực (NĐ số 31/2017/NĐ-CP)
 * ntduong2 11.1.2024
 */
const popupBUPlanExpenseReportB51 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanExpenseReportB51/BUPlanExpenseReportB51.vue'),
);

/**
 *
 */
const popupBUPlancheckFormularOverview = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanCheckFormular/CheckFormularOverview.vue'),
);
const popupBUPlanCheckBalanceFormularOverview = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanCheckFormular/CheckBalanceFormularOverview.vue'),
);

/**
 *
 */
const popupBUPlanAddFormular = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanCheckFormular/AddFormularPopup.vue'),
);

const popupBUPlanAddFormularTT342 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanCheckFormular/AddFormularTT342Popup.vue'),
);

const popupChooseActivity = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanCheckFormular/ChooseActivity.vue'),
);

const popupDetailVoucherRelated = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanCheckFormular/DetailVoucherRelated.vue'),
);

/**
 * Báo cáo cân đối chi theo NDKT
 * nhhoang1 14.04.2023
 */
const popupBUPlanActivityTemplateBySymmetrical = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/BUPlanActivityTemplateBySymmetrical.vue'),
);

/**
 * Báo cáo cân đối chi theo NDKT
 * nhhoang1 14.04.2023
 */
const popupBUPlanReceiptExpenseReportB52 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/BUPlanReceiptExpenseReportB52.vue'),
);

/**
 * Báo cáo theo chỉ tiêu chi
 * nxhung 14.04.2023
 */
const buReportSpendingTargetDetail = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/BUReportSpendingTargetDetail.vue'),
);

/**
 * mẫu báo cáo 04.b TT
 * htthoa (31.08.2023)
 */
const buReportRecoveryCapital = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/04BTT_ND992021/ReportRecoveryCapital04BTT.vue'),
);

const VoucherBudgetAdditionPTCQuan4 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/voucherBudgetAdditionPTCQuan4/VoucherBudgetAdditionPTCQuan4.vue'),
);

// so sánh đối chiếu chỉ tiêu 07 với 08, 09
const activityComparedList_07_0809 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/activityCompared/ActivityComparedList_07_0809.vue'),
);

// so sánh đối chiếu chỉ tiêu 113 với 114, 115 (biểu 116 với 117 + 118)
const activityCompareReport = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/activityCompared/activityCompareReport/ActivityCompareReport.vue'),
);

const adjustActivitySymmetPopup = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/activityCompared/AdjustActivitySymmetPopup.vue'),
);

// so sánh đối chiếu chỉ tiêu 07 với 08, 09
const report60Compare_0809 = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buReport60Compare_0809/Report60Compare_0809.vue'),
);
const popupPlanBalanceAddFormular = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanCheckFormular/AddBalanceFormularPopup.vue'),
);

// kiểm tra định mức
const checkRegulationResultListPopup = defineAsyncComponent(() =>
  import('@/views/checkNorm/CheckRegulationResultListPopup.vue'),
);
const examinationResultPopup = defineAsyncComponent(() => import('@/views/checkNorm/ExaminationResultPopup.vue'));
const searchNormRegulationPopup = defineAsyncComponent(() => import('@/views/checkNorm/SearchNormRegulationPopup.vue'));

// popup thêm thiết lập chỉ tiêu cho chỉ tiêu ko cộng lên tổng
const addFormularNoPlusParentPopup = defineAsyncComponent(() =>
  import('@/views/budgetPlan/buPlanReport/buPlanCheckFormular/AddFormularNoPlusParentPopup.vue'),
);

export function registerBudgetPlan(app) {
  const registerConfig = {
    BUPlanReceiptAddMLNSDetail: popupBudgetPlan,
    BUPlanReceiptAdjustMLNSDetail: popupBUPlanAdjustMLNS,
    BUPlanReceiptAddTT342Detail: popupBUPlanAddTT342,
    BUPlanReceiptAdjustTT342Detail: popupBUPlanAdjustTT342,
    BUPlanReceiptAddTT343Detail: popupBUPlanAddTT343,
    BUPlanReceiptAdjustTT343Detail: popupBUPlanAdjustTT343,
    BUPlanReceiptAddTT344Detail: popupBUPlanAddTT344,
    BUPlanReceiptAdjustTT344Detail: popupBUPlanAdjustTT344,
    BudgetPlanningUtilityPopup: popupBudgetPlanUtility,
    BUInvestmentPlanXDCBDetail: popupInvestmentPlanXDCB,
    BUFinancialActivitiesDetail: popupFinancialActivities,
    BUTemplateReceiptTT342Detail: popupTemplateReceiptTT342,
    BUTemplateReceiptFormularTT342Popup: popupTemplateReceiptFormularTT342,
    BUTemplateExpenseTT342Detail: popupTemplateExpenseTT342,
    BUTemplateExpenseFormularTT342Popup: popupTemplateExpenseFormularTT342,
    BUTemplateReceiptTT343344Detail: popupTemplateReceiptTT343_344,
    BUTemplateReceiptFormularTT343344Popup: popupTemplateReceiptFormularTT343_344,
    BUTemplateExpenseTT343344Detail: popupTemplateExpenseTT343_344,
    BUTemplateExpenseFormularTT343344Popup: popupTemplateExpenseFormularTT343_344,
    BUAddMLNSPrintPopup: popupAddMLNSPrintPopup,
    // Form chi tiết cho chuyển khoản kho bạc
    BUTransferDetail: buTransferDetail,
    BUTransferDepositDetail: buTransferDepositDetail,
    // Form chi tiết cho hủy dự toán
    BUPlanCancelDetail: buCancelPlanDetail,
    BUBudgetReserveDetail: buBudgetReserveDetail,

    BUCommitmentRequestDetail: buPlanCommitExpenseDetail, // Form chi tiết cho đề nghị cam kết chi
    BUPlanAdjustCommitDetail: buPlanAdjustCommitDetail, // Form chi tiết cho điều chỉnh cam kết chi
    BUPlanCommitExpenseSelect: buPlanCommitExpenseSelect, // Form chọn cam kết chi trong điều chỉnh cam kết chi

    BUPlanExpenseByBudgetSupplementDetail: buPlanExpenseByBudgetSupplementDetail,
    BUPlanExpenseByActivitySupplement342Detail: buPlanExpenseByActivitySupplement342Detail,
    BUPlanExpenseByActivitySupplement343Detail: buPlanExpenseByActivitySupplement343Detail,
    BUPlanExpenseByActivitySupplementAdjust343Detail: buPlanExpenseByActivitySupplementAdjust343Detail,
    BUPlanExpenseByActivitySupplement344Detail: buPlanExpenseByActivitySupplement344Detail,
    BUPlanExpenseByActivitySupplementAdjust344Detail: buPlanExpenseByActivitySupplementAdjust344Detail,
    BUPlanExpenseByActivitySupplementVtDetail: buPlanExpenseByActivitySupplementVtDetail,
    BUPlanExpenseByActivitySupplementAdjustVtDetail: buPlanExpenseByActivitySupplementAdjustVtDetail,
    BUPlanExpenseByActivitySupplementAdjust342Detail: buPlanExpenseByActivitySupplementAdjust342Detail,
    BUPlanExpenseByBudgetSupplementAdjustDetail: buPlanExpenseByBudgetSupplementAdjustDetail,

    BUAdvancePaymentDetail: buAdvancePaymentDetail,
    BUReceiptExpenseDetail: buReceiptExpenseDetail,
    BUAdvancePaymentExpenceDetail: buAdvancePaymentExpenceDetail,
    BUTreasuryWithdrawalDetail: buTreasuryWithdrawalDetail,
    VoucherNotReference: voucherNotReference,
    BUPlanSummaryReceiptMLNSDetail: buPlanSummaryReceiptMLNSDetail,
    BUPlanSummaryReceiptTT342Detail: buPlanSummaryReceiptTT342Detail,
    BUPlanSummaryReceiptTT343Detail: buPlanSummaryReceiptTT343Detail,
    BUPlanSummaryReceiptTT344Detail: buPlanSummaryReceiptTT344Detail,
    BUPlanSummaryPaymentMLNSDetail: buPlanSummaryPaymentMLNSDetail,
    BUPlanSummaryPaymentTT342Detail: buPlanSummaryPaymentTT342Detail,
    BUPlanSummaryPaymentTT343Detail: buPlanSummaryPaymentTT343Detail,
    BUPlanSummaryPaymentTT344Detail: buPlanSummaryPaymentTT344Detail,
    BUReceiveBudgetPlanDetail: buEceiveBudgetPlanDetail,
    BUPlanAdjustmentDetail: buPlanAdjustmentDetail,
    BUExpenseWithdrawAdjustmentDetail: buAdjustmentDetail,
    BUGetDataAdjustmentDetail: buGetDataAdjustmentDetail,
    BudgetPlanAdjustmentDetail: budgetPlanAdjustmentDetail,
    BUReportSpendingTargetDetail: buReportSpendingTargetDetail,
    BUPlanReceiptExpenseReportB61B62: popupBUPlanReceiptExpenseReportB61B62,
    BUPlanReceiptExpenseReportB48: popupBUPlanReceiptExpenseReportB48,
    BUPlanExpenseReportB51: popupBUPlanExpenseReportB51,
    BUPlancheckFormularOverview: popupBUPlancheckFormularOverview,
    BUPlanCheckBalanceFormularOverview: popupBUPlanCheckBalanceFormularOverview,
    PopupBUPlanAddFormular: popupBUPlanAddFormular,
    PopupBUPlanAddFormularTT342: popupBUPlanAddFormularTT342,
    ChooseActivityPopup: popupChooseActivity,
    DetailVoucherRelated: popupDetailVoucherRelated,
    BUPlanActivityTemplateBySymmetrical: popupBUPlanActivityTemplateBySymmetrical,
    BUPlanReceiptExpenseReportB52: popupBUPlanReceiptExpenseReportB52,
    BUChooseBudgetSupplementAdjust: popupBUChooseBudgetSupplementAdjust,
    ReportRecoveryCapital04BTT: buReportRecoveryCapital,

    // Chứng từ nghiệp vụ khác
    VoucherBudgetAdditionPTCQuan4: VoucherBudgetAdditionPTCQuan4,

    // so sánh đối chiếu chỉ tiêu 07 với 08, 09
    ActivityComparedList_07_0809: activityComparedList_07_0809,

    // so sánh đối chiếu chỉ tiêu 01137 với 114, 115
    ActivityCompareReport: activityCompareReport,
    AdjustActivitySymmetPopup: adjustActivitySymmetPopup,

    Report60Compare_0809: report60Compare_0809,
    PopupPlanBalanceAddFormular: popupPlanBalanceAddFormular,
    //#region Thư viện mẫu báo cáo
    ReportTemplateLibrary: reportTemplateLibrary,
    ShareLocation: shareLocation,
    ShowReportTemplate: showReportTemplate,
    DisplaySettingsFrame: displaySettingsFrame,
    ReceiptExpenseReportB61B62Tab: receiptExpenseReportB61B62Tab,
    ReportSpendingTargetTab: reportSpendingTargetTab,
    ActivityTemplateBySymmetricalTab: activityTemplateBySymmetricalTab,
    TemplateReceiptExpenseTab: templateReceiptExpenseTab,
    CheckRegulationResultListPopup: checkRegulationResultListPopup,
    ExaminationResultPopup: examinationResultPopup,
    SearchNormRegulationPopup: searchNormRegulationPopup,
    AddFormularNoPlusParentPopup: addFormularNoPlusParentPopup,
    //#endregion
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'BudgetPlan');
}
